/**
 * Catálogo amplio de POIs Hermes: kinds, etiquetas, indoor/outdoor/pago y consultas Overpass.
 * Objetivo: cientos/miles de actividades reales (no solo aventura extrema).
 */

export const PLACE_KIND_LABELS: Record<string, string> = {
  cafe: "Café",
  bar: "Bar",
  restaurant: "Restaurante",
  fast_food: "Comida rápida",
  mcdonalds: "McDonald's",
  burgerking: "Burger King",
  museum: "Museo",
  monument: "Monumento",
  park: "Parque",
  library: "Biblioteca",
  cinema: "Cine",
  theatre: "Teatro",
  supermarket: "Supermercado",
  plaza: "Plaza",
  square: "Plaza",
  books: "Librería",
  bakery: "Panadería",
  shop: "Tienda",
  clothes: "Ropa",
  furniture: "Muebles",
  hardware: "Ferretería",
  doityourself: "Bricolaje / construcción",
  mall: "Centro comercial",
  department_store: "Grandes almacenes",
  gift: "Regalos",
  electronics: "Electrónica",
  sports_shop: "Tienda deporte",
  jewelry: "Joyería",
  florist: "Floristería",
  convenience: "Tienda de barrio",
  variety: "Bazar",
  second_hand: "Segunda mano",
  gallery: "Galería de arte",
  viewpoint: "Mirador",
  church: "Iglesia",
  castle: "Castillo",
  attraction: "Atracción",
  artwork: "Obra / arte urbano",
  ruins: "Ruinas",
  townhall: "Ayuntamiento",
  pharmacy: "Farmacia",
  post: "Correos",
  laundry: "Lavandería",
  marketplace: "Mercadillo",
  bowling: "Bolera",
  sport: "Deporte",
  nightclub: "Discoteca",
  mountain: "Montaña",
  bridge: "Puente",
  cave: "Cueva",
  kart: "Karts",
  ski: "Pista de esquí",
  bungee: "Puenting",
  parachuting: "Paracaidismo",
  zoo: "Zoo",
  aquarium: "Acuario",
  theme_park: "Parque temático",
  water_park: "Parque acuático",
  circus: "Circo",
  stadium: "Estadio",
  swimming: "Piscina",
  climbing: "Escalada",
  beach: "Playa",
  camp_site: "Camping",
  hotel: "Hotel",
  hostel: "Hostel",
  guest_house: "Casa rural / pensión",
  historic: "Lugar histórico",
  memorial: "Memorial",
  archaeological: "Yacimiento",
  film_location: "Rodaje / cine en exteriores",
  fountain: "Fuente",
  picnic: "Picnic",
  dog_park: "Parque canino",
  miniature_golf: "Mini-golf",
  escape_game: "Escape room",
  casino: "Casino",
  arts_centre: "Centro cultural",
  community_centre: "Centro cívico",
  music_venue: "Sala de conciertos",
  dance: "Baile / academia",
  ice_cream: "Heladería",
  biergarten: "Terraza / cervecería",
  university: "Universidad",
  school: "Escuela",
  hospital: "Hospital",
  bank: "Banco",
  atm: "Cajero",
  fuel: "Gasolinera",
  parking: "Parking",
  bus_station: "Estación de bus",
  railway: "Estación de tren",
  airport: "Aeropuerto",
  marina: "Puerto deportivo",
  vineyard: "Viñedo",
  winery: "Bodega",
  farm: "Granja",
  garden: "Jardín",
  nature_reserve: "Reserva natural",
  waterfall: "Cascada",
  spring: "Manantial",
  forest: "Bosque",
  amusement_arcade: "Salón recreativo",
  paintball: "Paintball",
  golf: "Golf",
  horse: "Hípica",
  diving: "Buceo",
  sailing: "Vela",
  fitness: "Gimnasio",
  yoga: "Yoga",
  spa: "Spa / wellness",
  hairdresser: "Peluquería",
  beauty: "Estética",
  tattoo: "Tatuajes",
  optician: "Óptica",
  car_repair: "Taller",
  car_wash: "Lavadero",
  bicycle: "Bicicletas",
  toys: "Juguetería",
  pet: "Mascotas",
  alcohol: "Bodega / licores",
  chocolate: "Chocolatería",
  seafood: "Marisquería",
  butcher: "Carnicería",
  greengrocer: "Frutería",
  cheese: "Quesería",
  tea: "Tetería",
  wine: "Vinoteca",
  coworking: "Coworking",
  conference: "Congresos",
  exhibition: "Exposición",
  observatory: "Observatorio",
  planetarium: "Planetario",
  lighthouse: "Faro",
  tower: "Torre",
  fort: "Fuerte",
  monastery: "Monasterio",
  synagogue: "Sinagoga",
  mosque: "Mezquita",
  cemetery: "Cementerio histórico",
  wheelchair: "Accesible",
  lugar: "Lugar",
};

export const KIND_FALLBACK_NAME: Record<string, string> = { ...PLACE_KIND_LABELS };

export const OUTDOOR_KINDS = new Set([
  "park",
  "plaza",
  "square",
  "viewpoint",
  "monument",
  "castle",
  "ruins",
  "attraction",
  "marketplace",
  "mountain",
  "bridge",
  "artwork",
  "church",
  "cave",
  "ski",
  "bungee",
  "parachuting",
  "zoo",
  "theme_park",
  "water_park",
  "circus",
  "stadium",
  "beach",
  "camp_site",
  "historic",
  "memorial",
  "archaeological",
  "film_location",
  "fountain",
  "picnic",
  "dog_park",
  "garden",
  "nature_reserve",
  "waterfall",
  "forest",
  "golf",
  "marina",
  "vineyard",
  "farm",
  "lighthouse",
  "tower",
  "fort",
  "cemetery",
  "biergarten",
]);

export const INDOOR_KINDS = new Set([
  "museum",
  "library",
  "cinema",
  "theatre",
  "gallery",
  "cafe",
  "bar",
  "restaurant",
  "fast_food",
  "mcdonalds",
  "burgerking",
  "shop",
  "clothes",
  "furniture",
  "hardware",
  "doityourself",
  "mall",
  "department_store",
  "supermarket",
  "bakery",
  "books",
  "bowling",
  "sport",
  "nightclub",
  "kart",
  "aquarium",
  "escape_game",
  "casino",
  "arts_centre",
  "community_centre",
  "music_venue",
  "ice_cream",
  "fitness",
  "spa",
  "hairdresser",
  "beauty",
  "amusement_arcade",
  "planetarium",
  "observatory",
  "coworking",
  "hotel",
  "hostel",
]);

export const PAID_KINDS = new Set([
  "cafe",
  "bar",
  "restaurant",
  "fast_food",
  "mcdonalds",
  "burgerking",
  "cinema",
  "theatre",
  "supermarket",
  "bakery",
  "shop",
  "clothes",
  "furniture",
  "hardware",
  "doityourself",
  "mall",
  "books",
  "bowling",
  "nightclub",
  "kart",
  "ski",
  "bungee",
  "parachuting",
  "museum",
  "zoo",
  "aquarium",
  "theme_park",
  "water_park",
  "circus",
  "escape_game",
  "casino",
  "spa",
  "fitness",
  "hotel",
  "hostel",
  "golf",
  "paintball",
  "swimming",
]);

export const FREE_KINDS = new Set([
  "park",
  "plaza",
  "square",
  "monument",
  "viewpoint",
  "library",
  "gallery",
  "church",
  "castle",
  "attraction",
  "artwork",
  "ruins",
  "townhall",
  "mountain",
  "bridge",
  "marketplace",
  "cave",
  "historic",
  "memorial",
  "archaeological",
  "film_location",
  "fountain",
  "picnic",
  "dog_park",
  "garden",
  "nature_reserve",
  "beach",
  "forest",
  "plaza",
  "cemetery",
  "lighthouse",
]);

/** Consultas Photon/Nominatim en paralelo para rellenar huecos. */
export const SEARCH_FALLBACK_QUERIES: { q: string; kind: string }[] = [
  { q: "cafe", kind: "cafe" },
  { q: "bar", kind: "bar" },
  { q: "park", kind: "park" },
  { q: "museum", kind: "museum" },
  { q: "cinema", kind: "cinema" },
  { q: "library", kind: "library" },
  { q: "plaza", kind: "plaza" },
  { q: "restaurant", kind: "restaurant" },
  { q: "McDonald's", kind: "mcdonalds" },
  { q: "Burger King", kind: "burgerking" },
  { q: "bowling", kind: "bowling" },
  { q: "bakery", kind: "bakery" },
  { q: "supermarket", kind: "supermarket" },
  { q: "tienda ropa", kind: "clothes" },
  { q: "muebles", kind: "furniture" },
  { q: "ferreteria", kind: "hardware" },
  { q: "bricolaje", kind: "doityourself" },
  { q: "bazar", kind: "variety" },
  { q: "mercadillo", kind: "marketplace" },
  { q: "galeria arte", kind: "gallery" },
  { q: "discoteca", kind: "nightclub" },
  { q: "mirador", kind: "viewpoint" },
  { q: "castillo", kind: "castle" },
  { q: "monumento", kind: "monument" },
  { q: "ruinas", kind: "ruins" },
  { q: "zoo", kind: "zoo" },
  { q: "acuario", kind: "aquarium" },
  { q: "circo", kind: "circus" },
  { q: "parque tematico", kind: "theme_park" },
  { q: "estadio", kind: "stadium" },
  { q: "cine", kind: "cinema" },
  { q: "teatro", kind: "theatre" },
  { q: "puente", kind: "bridge" },
  { q: "cueva", kind: "cave" },
  { q: "kart", kind: "kart" },
  { q: "paracaidismo", kind: "parachuting" },
  { q: "escaperoom", kind: "escape_game" },
  { q: "gimnasio", kind: "fitness" },
  { q: "spa", kind: "spa" },
  { q: "playa", kind: "beach" },
  { q: "fuente", kind: "fountain" },
  { q: "iglesia", kind: "church" },
  { q: "centro comercial", kind: "mall" },
  { q: "heladeria", kind: "ice_cream" },
  { q: "planetario", kind: "planetarium" },
  { q: "observatorio", kind: "observatory" },
  { q: "faro", kind: "lighthouse" },
  { q: "monasterio", kind: "monastery" },
  { q: "yacimiento", kind: "archaeological" },
  { q: "rodaje pelicula", kind: "film_location" },
];

export function buildOverpassQuery(around: string, limit = 600): string {
  return `[out:json][timeout:28];(
  nwr${around}["amenity"~"cafe|bar|pub|restaurant|fast_food|library|cinema|theatre|pharmacy|post_office|laundry|marketplace|place_of_worship|townhall|ice_cream|biergarten|nightclub|arts_centre|community_centre|university|college|school|hospital|bank|atm|fuel|parking|bus_station|cinema|theatre|casino|coworking_space|conference_centre|exhibition_centre|music_venue|dance|bbq|fountain|public_bath|social_facility"];
  nwr${around}["shop"];
  nwr${around}["leisure"~"park|garden|nature_reserve|playground|bowling_alley|sports_centre|fitness_centre|pitch|track|ski_resort|stadium|swimming_pool|water_park|miniature_golf|dog_park|picnic_table|beach_resort|escape_game|adult_gaming_centre|amusement_arcade|hackerspace|sports_hall|ice_rink|horse_riding|marina|sauna"];
  nwr${around}["sport"];
  nwr${around}["tourism"~"museum|gallery|viewpoint|attraction|artwork|zoo|aquarium|theme_park|hotel|hostel|guest_house|motel|camp_site|caravan_site|information|picnic_site|yes"];
  nwr${around}["historic"];
  nwr${around}["building"~"church|cathedral|chapel|mosque|synagogue|temple|castle|ruins|tower|bunker"];
  nwr${around}["place"="square"];
  nwr${around}["natural"~"peak|ridge|volcano|cave_entrance|cave|beach|wood|forest|waterfall|spring|cliff"];
  nwr${around}["man_made"~"bridge|lighthouse|tower|obelisk|cross|windmill"];
  nwr${around}["piste:type"];
  nwr${around}["aeroway"~"aerodrome|helipad"];
  nwr${around}["railway"="station"];
  nwr${around}["landuse"~"vineyard|orchard|farmyard|recreation_ground|village_green"];
  nwr${around}["craft"];
  nwr${around}["office"~"coworking|estate_agent|lawyer|insurance"];
  nwr${around}["brand"~"McDonald|Burger.?King|KFC|Starbucks|Subway",i];
);out center ${limit};`;
}

export function normalizePlaceKind(tags: Record<string, string>): string {
  const name = `${tags.name || ""} ${tags.brand || ""} ${tags.operator || ""}`.toLowerCase();
  if (/mcdonald/.test(name)) return "mcdonalds";
  if (/burger\s*king/.test(name)) return "burgerking";
  if (/paracaid|skydiv|parachut/.test(name)) return "parachuting";
  if (/puenting|bungee/.test(name)) return "bungee";
  if (/escape\s*room|escaperoom/.test(name)) return "escape_game";
  if (/circo|circus/.test(name)) return "circus";
  if (/rodaje|film\s*location|plató|plato de cine|cinema location/.test(name)) return "film_location";

  if (tags.amenity === "cafe") return "cafe";
  if (tags.amenity === "ice_cream") return "ice_cream";
  if (tags.amenity === "bar" || tags.amenity === "pub") return "bar";
  if (tags.amenity === "biergarten") return "biergarten";
  if (tags.amenity === "nightclub" || tags.amenity === "stripclub") return "nightclub";
  if (tags.amenity === "fast_food") return "fast_food";
  if (tags.amenity === "restaurant") return "restaurant";
  if (tags.amenity === "library") return "library";
  if (tags.amenity === "cinema") return "cinema";
  if (tags.amenity === "theatre") return "theatre";
  if (tags.amenity === "arts_centre") return "arts_centre";
  if (tags.amenity === "community_centre") return "community_centre";
  if (tags.amenity === "casino") return "casino";
  if (tags.amenity === "fountain") return "fountain";
  if (tags.amenity === "marketplace") return "marketplace";
  if (tags.amenity === "pharmacy") return "pharmacy";
  if (tags.amenity === "post_office") return "post";
  if (tags.amenity === "laundry") return "laundry";
  if (tags.amenity === "university" || tags.amenity === "college") return "university";
  if (tags.amenity === "school") return "school";
  if (tags.amenity === "hospital") return "hospital";
  if (tags.amenity === "bank") return "bank";
  if (tags.amenity === "atm") return "atm";
  if (tags.amenity === "fuel") return "fuel";
  if (tags.amenity === "parking") return "parking";
  if (tags.amenity === "bus_station") return "bus_station";
  if (tags.amenity === "music_venue") return "music_venue";
  if (tags.amenity === "conference_centre") return "conference";
  if (tags.amenity === "exhibition_centre" || tags.amenity === "events_venue") return "exhibition";
  if (tags.amenity === "coworking_space") return "coworking";
  if (tags.amenity === "place_of_worship" || tags.building === "church" || tags.building === "cathedral") {
    if (tags.religion === "muslim" || tags.building === "mosque") return "mosque";
    if (tags.religion === "jewish" || tags.building === "synagogue") return "synagogue";
    return "church";
  }
  if (tags.amenity === "townhall") return "townhall";

  if (tags.tourism === "museum") return "museum";
  if (tags.tourism === "gallery") return "gallery";
  if (tags.tourism === "viewpoint") return "viewpoint";
  if (tags.tourism === "zoo") return "zoo";
  if (tags.tourism === "aquarium") return "aquarium";
  if (tags.tourism === "theme_park") return "theme_park";
  if (tags.tourism === "hotel") return "hotel";
  if (tags.tourism === "hostel") return "hostel";
  if (tags.tourism === "guest_house" || tags.tourism === "motel") return "guest_house";
  if (tags.tourism === "camp_site" || tags.tourism === "caravan_site") return "camp_site";
  if (tags.tourism === "attraction") return "attraction";
  if (tags.tourism === "artwork") return "artwork";
  if (tags.tourism === "picnic_site") return "picnic";

  if (tags.natural === "peak" || tags.natural === "ridge" || tags.natural === "volcano") return "mountain";
  if (tags.natural === "cave_entrance" || tags.natural === "cave") return "cave";
  if (tags.natural === "beach") return "beach";
  if (tags.natural === "waterfall") return "waterfall";
  if (tags.natural === "spring") return "spring";
  if (tags.natural === "wood" || tags.natural === "forest") return "forest";

  if (tags.man_made === "bridge" || tags.bridge === "yes") return "bridge";
  if (tags.man_made === "lighthouse") return "lighthouse";
  if (tags.man_made === "tower" || tags.building === "tower") return "tower";

  // En una tienda, `sport` dice qué vende (shop=sports + sport=soccer), no que sea una instalación deportiva.
  const sport = tags.shop ? "" : tags.sport || "";
  if (tags.leisure === "park" || tags.leisure === "playground") return "park";
  if (tags.leisure === "garden") return "garden";
  if (tags.leisure === "nature_reserve") return "nature_reserve";
  if (tags.leisure === "bowling_alley" || sport === "bowling") return "bowling";
  if (tags.leisure === "water_park") return "water_park";
  if (tags.leisure === "stadium") return "stadium";
  if (tags.leisure === "swimming_pool" || sport === "swimming") return "swimming";
  if (tags.leisure === "dog_park") return "dog_park";
  if (tags.leisure === "picnic_table") return "picnic";
  if (tags.leisure === "miniature_golf") return "miniature_golf";
  if (tags.leisure === "escape_game") return "escape_game";
  if (tags.leisure === "amusement_arcade" || tags.leisure === "adult_gaming_centre") return "amusement_arcade";
  if (tags.leisure === "fitness_centre" || tags.leisure === "sports_centre" || tags.leisure === "sports_hall") {
    return tags.leisure === "fitness_centre" ? "fitness" : "sport";
  }
  if (tags.leisure === "pitch") return "sport";
  if (tags.leisure === "marina") return "marina";
  if (tags.leisure === "sauna") return "spa";
  if (tags.leisure === "horse_riding" || sport === "horse_racing") return "horse";
  if (tags.leisure === "golf_course" || sport === "golf") return "golf";
  if (tags.leisure === "beach_resort") return "beach";
  if (tags.leisure === "ice_rink") return "sport";

  if (sport === "karting" || (tags.leisure === "track" && /kart/i.test(tags.name || ""))) return "kart";
  if (sport === "skiing" || tags.leisure === "ski_resort" || tags.piste === "yes" || tags["piste:type"]) {
    return "ski";
  }
  if (sport === "bungee_jumping") return "bungee";
  if (sport === "parachuting" || sport === "skydiving") return "parachuting";
  if (sport === "climbing" || sport === "climbing_adventure") return "climbing";
  if (sport === "scuba_diving" || sport === "diving") return "diving";
  if (sport === "sailing") return "sailing";
  if (sport === "paintball") return "paintball";
  if (sport === "yoga") return "yoga";
  if (sport) return "sport";

  if (tags.shop === "supermarket") return "supermarket";
  if (tags.shop === "bakery") return "bakery";
  if (tags.shop === "books") return "books";
  if (tags.shop === "clothes" || tags.shop === "fashion" || tags.shop === "boutique") return "clothes";
  if (tags.shop === "furniture") return "furniture";
  if (tags.shop === "hardware") return "hardware";
  if (tags.shop === "doityourself") return "doityourself";
  if (tags.shop === "mall") return "mall";
  if (tags.shop === "department_store") return "department_store";
  if (tags.shop === "gift") return "gift";
  if (tags.shop === "electronics") return "electronics";
  if (tags.shop === "sports") return "sports_shop";
  if (tags.shop === "jewelry") return "jewelry";
  if (tags.shop === "florist") return "florist";
  if (tags.shop === "convenience") return "convenience";
  if (tags.shop === "variety_store" || tags.shop === "general") return "variety";
  if (tags.shop === "second_hand" || tags.shop === "charity") return "second_hand";
  if (tags.shop === "bicycle") return "bicycle";
  if (tags.shop === "toys") return "toys";
  if (tags.shop === "pet") return "pet";
  if (tags.shop === "alcohol") return "alcohol";
  if (tags.shop === "chocolate") return "chocolate";
  if (tags.shop === "seafood") return "seafood";
  if (tags.shop === "butcher") return "butcher";
  if (tags.shop === "greengrocer") return "greengrocer";
  if (tags.shop === "cheese") return "cheese";
  if (tags.shop === "tea") return "tea";
  if (tags.shop === "wine") return "wine";
  if (tags.shop === "hairdresser") return "hairdresser";
  if (tags.shop === "beauty" || tags.shop === "cosmetics") return "beauty";
  if (tags.shop === "tattoo") return "tattoo";
  if (tags.shop === "optician") return "optician";
  if (tags.shop === "car_repair") return "car_repair";
  if (tags.shop === "car_wash") return "car_wash";
  if (tags.shop) return "shop";

  if (tags.historic === "castle" || tags.building === "castle") return "castle";
  if (tags.historic === "ruins" || tags.building === "ruins") return "ruins";
  if (tags.historic === "monument") return "monument";
  if (tags.historic === "memorial") return "memorial";
  if (tags.historic === "archaeological_site") return "archaeological";
  if (tags.historic === "fort" || tags.historic === "citywalls") return "fort";
  if (tags.historic === "monastery" || tags.historic === "wayside_shrine") return "monastery";
  if (tags.historic === "cemetery" || tags.landuse === "cemetery") return "cemetery";
  if (tags.historic) return "historic";

  if (tags.aeroway === "aerodrome") return "airport";
  if (tags.railway === "station") return "railway";
  if (tags.landuse === "vineyard") return "vineyard";
  if (tags.landuse === "farmyard" || tags.landuse === "orchard") return "farm";
  if (tags.place === "square") return "plaza";
  if (tags.building === "mosque") return "mosque";
  if (tags.building === "synagogue") return "synagogue";

  if (tags.tourism === "yes" && tags.historic) return "historic";
  if (tags.craft) return "shop";

  return tags.amenity || tags.tourism || tags.leisure || tags.shop || tags.historic || tags.natural || "lugar";
}
